import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import { Anchor } from './PartnersCard.style'

const PartnersCardLink = ({ children, url }) => {
  return url ? (
    <Anchor as={Link} to={url}>
      {children}
    </Anchor>
  ) : (
    <>{children}</>
  )
}

PartnersCardLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  url: PropTypes.string,
}

PartnersCardLink.defaultProps = {
  children: '',
  url: '',
}

export default PartnersCardLink
